module.exports = __webpack_public_path__ + "static/media/sr.3eddc633.webp";